<template>
  <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
    <a-form @submit="handleSubmit" :form="form">
      <a-form-item label="类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select placeholder="请选择" v-decorator="[
          'type',
          {
            rules: [{ required: true, message: '未选择类型' }],
            initialValue: info.type
          }
        ]">
          <a-select-option v-for="(option, key) in type" :key="key" :value="key">{{ option }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="[
          'title',
          {
            rules: [{ required: true, message: '标题不能为空' }],
            initialValue: info.title
          },
        ]" placeholder="公告标题" />
      </a-form-item>
      <a-form-item label="内容" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea rows="5" placeholder="请输入公告内容" v-decorator="[
          'contents',
          {
            rules: [{ required: true, message: '公告内容不能为空' }],
            initialValue: info.contents
          }
        ]" />
      </a-form-item>
      <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-checkbox v-decorator="[
          'status',
          {
            valuePropName: 'checked',
            initialValue: infoStatus,
          },
        ]">
          是否启用
        </a-checkbox>
      </a-form-item>
      <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
        <a-button htmlType="submit" :loading="submitLoading" type="primary">提交</a-button>
        <a-button style="margin-left: 8px" @click="routerback">返回</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
import { announceRead, announceEdit, announceAdd, announceType } from '@/api/announcement'

export default {
  name: 'EditNoticeTemplate',
  data() {
    return {
      description: '公告编辑添加',
      value: 1,
      fontStyle: {
        fontWeight: 1000
      },
      labelCol: {
        lg: { span: 7 },
        sm: { span: 7 }
      },
      wrapperCol: {
        lg: { span: 10 },
        sm: { span: 17 }
      },
      customLabelCol: {
        lg: { span: 4 },
        sm: { span: 7 }
      },
      customWrapperCol: {
        lg: { span: 18 },
        sm: { span: 17 }
      },
      queryData: {},
      checkPass: true,
      type: {},
      info: {
        'type': 'all'
      },
      infoStatus: false,
      pageType: 'add', // 当前页面是新增(add),还是修改(edit)

      // form
      form: this.$form.createForm(this),
      submitLoading: false
    }
  },
  created() {
    const id = this.$route.query.id
    this.queryData.id = id
    if (id !== undefined) {
      this.pageType = 'edit'
      this.loadInfo(id)
    } else {
      this.loadType()
    }
  },
  methods: {
    loadInfo(id) {
      new Promise((resolve, reject) => {
        announceRead({ 'id': id }).then(response => {
          if (response.status === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
      }).then(res => {
        this.info = res.data.info
        if (res.data.info.status === 1) {
          this.infoStatus = true
        } else {
          this.infoStatus = false
        }
        this.type = res.data.type
      }).catch(error => {
        this.$notification.error({
          message: '错误',
          description: error.message
        })
        // 跳转回
        // setTimeout(() => {
        //     this.$router.back(-1)
        // }, 2000)
      })
    },
    loadType() {
      new Promise((resolve, reject) => {
        announceType().then(response => {
          if (response.status === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
      }).then(res => {
        this.type = res.data
      }).catch(error => {
        this.$notification.error({
          message: '错误',
          description: error.message
        })
        // 跳转回
        setTimeout(() => {
          this.$router.back(-1)
        }, 2000)
      })
    },
    // handler
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          values.status = values.status ? 1 : 0
          if (this.pageType === 'edit') {
            new Promise((resolve, reject) => {
              this.submitLoading = true
              values.id = this.queryData.id
              announceEdit(values).then(response => {
                if (response.status === 'success') {
                  resolve(response)
                } else {
                  reject(response)
                }
              })
            }).then(res => {
              this.$notification.success({
                message: res.status,
                description: res.message
              })
              // 跳转回列表页面
              setTimeout(() => {
                this.$router.back(-1)
              }, 2000)
            }).catch(error => {
              this.$notification.error({
                message: '错误',
                description: error.message
              })
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            // 新增
            new Promise((resolve, reject) => {
              this.submitLoading = true
              announceAdd(values).then(response => {
                if (response.status === 'success') {
                  resolve(response)
                } else {
                  reject(response)
                }
              })
            }).then(res => {
              this.$notification.success({
                message: res.status,
                description: res.message
              })
              // 跳转回列表
              setTimeout(() => {
                this.$router.back(-1)
              }, 2000)
            }).catch(error => {
              this.$notification.error({
                message: '错误',
                description: error.message
              })
            }).finally(() => {
              this.submitLoading = false
            })
          }
        }
      })
    },
    routerback: function () {
      this.$router.back(-1)
    }
  }
}
</script>
